import {
  unsubscribeFromMarketing,
  unsubscribeFromMarketingViaEmailId,
} from 'api/emails';
import MainLayout from 'components/layout/MainLayout';
import PageTitle from 'components/PageTitle';
import RoundedButton from 'components/RoundedButton';
import { NextSeo } from 'next-seo';
import Link from 'next/link';
import { useState } from 'react';
import { Input } from 'semantic-ui-react';

const Unsubscribe = (props) => {
  const [emailAddress, setEmailAddress] = useState(props.emailAddress ?? '');
  const emailType = props.emailType ?? null;
  const unsubscribingFromDPRReminderEmails = emailType === 'dpr_reminders';

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(props.result);

  return (
    <MainLayout>
      <NextSeo
        title="Unsubscribe | Win Epic Prizes | DAYMADE"
        openGraph={{
          title: 'Unsubscribe | Win Epic Prizes | DAYMADE',
        }}
      />

      <PageTitle>
        {props?.result?.successful ? (
          <>Unsubscribe</>
        ) : (
          <>
            Confirm <strong>Unsubscribe</strong>
          </>
        )}
      </PageTitle>

      <div
        className="paddedMaxWidthContainer"
        style={{ padding: '2em', textAlign: 'center' }}
      >
        {!result ? (
          <>
            <p style={{ fontWeight: 'bold', marginBottom: '1em' }}>
              Please confirm that you would like to unsubscribe from{' '}
              {unsubscribingFromDPRReminderEmails
                ? 'Pound Raffle reminder emails'
                : 'all future marketing emails from DAYMADE'}
              :
            </p>

            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                marginBottom: '1.5em',
                flexWrap: 'wrap',
              }}
            >
              <Input
                placeholder="Email Address"
                type="text"
                autoComplete="username"
                autoCorrect="off"
                onChange={(e) => setEmailAddress(e.target.value)}
                value={emailAddress}
                className="neonInput"
                style={{
                  borderRadius: '3px',
                  margin: '1em 0 0 0',
                  fontSize: '16px', // Don't zoom in on iOS
                }}
              />

              <RoundedButton
                onClick={async () => {
                  setLoading(true);
                  const result = await unsubscribeFromMarketing(
                    emailAddress,
                    emailType
                  );
                  setResult(result);
                  setLoading(false);
                }}
                style={{
                  margin: '1.4em 1em 0 1em',
                }}
                loading={loading}
              >
                Unsubscribe
              </RoundedButton>
            </div>
          </>
        ) : (
          <>
            {result.successful ? (
              <>
                <p style={{ fontWeight: 'bold' }}>
                  Your preference has been saved.
                  <br />
                  To re-enable marketing emails or adjust other email
                  preferences, visit the{' '}
                  <Link href="/account/email-preferences">
                    <a style={{ margin: 0, textDecoration: 'underline' }}>
                      email preferences
                    </a>
                  </Link>{' '}
                  part of your account.
                </p>
              </>
            ) : (
              <p style={{ color: 'red', fontWeight: 'bold' }}>
                Your preference could not be saved. {result.reason}
                <br />
                Please contact us via email: hello@daymade.co.uk
              </p>
            )}
          </>
        )}
      </div>
    </MainLayout>
  );
};

export const getServerSideProps = async (ctx) => {
  const { eid = null, emailAddress = null, emailType = null } = ctx.query;

  let result = null;
  if (eid) {
    result = await unsubscribeFromMarketingViaEmailId(eid, emailType);
  } else if (emailAddress) {
    result = await unsubscribeFromMarketing(emailAddress, emailType);
  }

  return {
    props: {
      result,
      emailAddress,
      emailType,
    },
  };
};

export default Unsubscribe;
